import classNames from 'classnames';

import buttonStyles from '~/components/common/Button/Button.module.css';

import styles from './PremiumBenefits.module.css';

export const PremiumBenefits = ({ resourcesUrl }: {resourcesUrl: string;}) => {
  const premiumBenefits = {
    grids: {
      heading: 'Unlimited Grids',
      text: 'Unlock unlimited access to our comparison grids and get the best odds across 40+ sports every single week.'
    },
    'racehorse-share': {
      heading: 'FREE Racehorse Share',
      text: 'Become a racehorse owner and claim your free share (worth £40) in an Oddschecker Unlimited exclusive horse racing syndicate courtesy of Racing Club.'
    },
    'expert-tools': {
      heading: 'Expert Tools',
      text: 'Unlock unlimited access to the latest innovative tools to inform your betting decisions.'
    },
    tips: {
      heading: 'Exclusive Tips',
      text: 'Unlock exclusive access to daily insight from all of our expert tipsters including Andy Holding, Ginger Joe, Road to Cheltenham, Niall Lyons and Steve Ryder.'
    },
    ads: {
      heading: 'Reduced Ad Experience',
      text: 'Unlock less ads for a smoother oddschecker experience by never seeing banner advertising or popups.'
    },
    access: {
      heading: 'Andy Holding access',
      text: 'Get unlimited access to Andy Holding’s daily horse racing column & selections'
    },
    insight: {
      heading: 'Extra Insight',
      text: 'Early look – Niall Lyons. Ante-post of the week – Steve Ryder. Weekend value pick – Mark O’Haire.'
    },
    insiders: {
      heading: 'OC Insiders',
      text: 'Become an OC Insider. Quicker replies. Direct Access. Monthly Tipster Q&As.'
    }
  };

  const linkClasses = classNames(buttonStyles.button, styles.linkButton);

  return (
    <ul className={styles.wrapper} data-testid="premium-benefits">
			{Object.entries(premiumBenefits).map(([type, { heading, text }]) => {
        return (
          <li className={styles.card} key={`premiun-benefit-${type}`}>
						<article>
							<div className={styles.textWrapper}>
								<img
                  alt=""
                  className={styles.image}
                  src={`${resourcesUrl}/assets/img/subscribe/${type}.png`} />

								<h2 className={styles.heading}>{heading}</h2>
								<p className={styles.text}>{text}</p>
							</div>
							<a
                className={linkClasses}
                href="https://www.oddschecker.com/unlimited-features"
                rel="noreferrer"
                target="_blank">

								Learn More
							</a>
						</article>
					</li>);

      })}
		</ul>);

};